export default "__VITE_ASSET__5UoqZiZh__"